import { AnimalsSecured } from '../../Types/AnimalStore'
import { RowsTableType } from '../SafeAnimalsPackageTable/InsuredObjects'
import { InfoCoverage } from './InfoCoverage'

type Props = {
  fieldCoverages: RowsTableType
  packId: string
  disabled?: boolean
  animal?: AnimalsSecured
}

export const FormatterFieldCoverages = ({
  fieldCoverages,
  packId,
  disabled,
  animal,
}: Props) => {
  const coverageId = fieldCoverages?.coverageId
  const coverages = fieldCoverages[packId]?.pack?.coverages

  const hasCoverage = coverages?.find(
    (coverage: any) => coverage?.coverageId === coverageId,
  )

  if (hasCoverage === undefined) {
    return <span>--</span>
  }

  return (
    <InfoCoverage
      isMandatory={hasCoverage?.mandatory}
      coverageId={coverageId as string}
      hasCoverage={hasCoverage}
      isDisabled={disabled}
      animal={animal}
    />
  )
}
